export function extractNodes(connectionField) {
  return connectionField?.edges.map(({ node }) => node) ?? [];
}
